import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import styles from "./adminmanageproduct.module.css";
import { useCookies } from 'react-cookie';
import { disableProduct, enableProduct, getAllProducts } from '../../apis/admin';
import { useEffect, useState } from 'react';
import LoadingScreen from '../LoadingScreen';

export default function AdminManageProducts() {
  const { t } = useTranslation();

  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);

  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAllProducts(cookies['access_token']).then((data) => {
      setProducts(data.data)
      setLoading(false)
    })
  }, [])

  const headers = [
    t('product_ID'),
    t('product_name'),
    t('category'),
    t('price'),
    t('stock_quantity'),
    t('supplier'),
    t('date_added'),
    t('last_updated'),
    t('actions')
  ];

  const lockProduct = (userId) => {
    disableProduct(userId, cookies['access_token'])
  }

  const unlockProduct = (userId) => {
    enableProduct(userId, cookies['access_token'])
  }

  return (
    loading ? <LoadingScreen />
      :
      <div className={styles.table_wrapper}>
        {headers.map((header, index) => (
          <div key={index} className={styles.table_header}>{header}</div>
        ))}
        {products.length > 0 ? (
          products.map((row) => (
            <div key={row.id} className={styles.table_row}>
              <div className={styles.table_cell}>{row.id}</div>
              <div className={styles.table_cell}>{row.name}</div>
              <div className={styles.table_cell}>{row.category}</div>
              <div className={styles.table_cell}>{row.price}</div>
              <div className={styles.table_cell}>{row.stock}</div>
              <div className={styles.table_cell}>{row.supplier}</div>
              <div className={styles.table_cell}>{row.dateAdded}</div>
              <div className={styles.table_cell}>{row.lastUpdated}</div>
              <div className={styles.table_cell}>
                {/* <button className={styles.iconButton1} onClick={()=>{}}>
                <EditIcon titleAccess={t('edit')} />
              </button> */}
                {row.status ?
                  <button className={styles.iconButton2} onClick={() => { lockProduct(row.id) }}>
                    <LockIcon titleAccess={t('lock_account')} />
                  </button>
                  :
                  <button className={styles.iconButton2} onClick={() => { unlockProduct(row.id) }}>
                    <LockOpenIcon titleAccess={t('unlock_account')} />
                  </button>
                }
              </div>
            </div>
          ))
        ) : (
          <div className={styles.no_data}>No data available</div>
        )}
      </div>
  );
}
